(function () {
    'use strict';

    angular
        .module('directives.systemsOwnedDecommissionPermissions', ['services.systemOwnerReview', 'services.employees'])
        .directive('systemsOwnedDecommissionSystems', directive);

    function directive() {
        return {
            scope: {
                authLogin: '=',
                systemsAndRoles: '=',
                readOnly: '='
            },
            restrict: 'AE',
            templateUrl: require('./systemsOwnedDecommissionPermissions.tpl.html'),
            controller: ['$scope', 'decommissionSystemsService', function ($scope, decommissionSystemsService) {

                $scope.updateDecision = function (system) {
                    system.IsSetForDecommission = !system.IsSetForDecommission;

                    decommissionSystemsService
                        .toggleSetForDecommission($scope.authLogin, [system.SystemID])
                        .then(function (updatedSystem) {
                            system = updatedSystem[0];
                        });
                }
            }]
        };
    }
})();
